import { Injectable } from '@angular/core';

import { decode, encode } from '../utilities/encoding.utility';
import { WindowService } from './window.service';

@Injectable({
    providedIn: 'root'
})
export class TextEncodingService {
    constructor(
        private readonly windowService: WindowService
    ) {
    }

    public async decode(data: Uint8Array): Promise<string> {
        return decode(data, this.windowService.nativeWindow);
    }

    public async encode(data: string): Promise<Uint8Array> {
        return encode(data, this.windowService.nativeWindow);
    }
}
